import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { db, auth } from "../../firebase/firebaseConfig";
import { doc, getDoc, setDoc } from "firebase/firestore";
import Button from "../../components/Button";
import logotipo from "../../images/logotipo-horizontal_con-nombre_recortado.png";

/* ============================================================
   OPCIONES Y SUBOPCIONES
============================================================ */

const OPCIONES = {
  valdisfagiacondiag: {
    label: "Valoración disfagia: Usuario/a con diagnóstico de disfagia orofaríngea",
    sub: [
      "Material necesario para realizar el MECV-V",
      "Método de Exploración Clínica Volumen-Viscosidad (MECV-V)",
      "Video 01 - Método de exploración clínica volumen viscosidad (MECV-V)",
      "Video 02 - Inicio del test de deglución: viscosidad líquida (agua)",
      "Video 03 - Inicio del test de deglución: viscosidad néctar",
      "Video 04 - Inicio del test de deglución: viscosidad pudín",
    ],
  },

  valdisfagiaconsos: {
    label: "Valoración disfagia: Usuario/a con sospecha de disfagia orofaríngea",
    sub: [
      "Eating Assessment Tool-10 (EAT-10)",
    ],
  },

  recomendaciones: {
    label: "Recomendaciones",
    sub: [
      "Recomendaciones generales",
      "Recomendaciones dietéticas generales",
      "Recomendaciones dietéticas sobre el uso de espesante",
      "Recomendaciones dietéticas características de la viscosidad néctar",
      "Recomendaciones dietéticas características de la consistencia pudín",
    ],
  },

  recetas: {
    label: "Recetas",
    sub: ["Recetas de disfagia", "Menús adaptados para disfagia: Menú textura néctar-miel (sin espesante)", "Menús adaptados para disfagia: Menú textura pudin (sin espesante)"],
  },

  ejercicios: {
    label: "Actividad / Ejercicio físico",
    sub: [
      "Ejercicio 01: Caminar (en llano y desnivel)",
      "Ejercicio 02: Sentadilla",
      "Ejercicio 03: Extensión de piernas",
      "Ejercicio 04: Inclinaciones laterales",
      "Ejercicio 05: Cerrar codos",
      "Ejercicio 06: Flexión de brazos",
      "Ejercicio 07: Fuerza de prensión manual",
      "Ejercicio 08: Extensión de rodillas en sedestación",
      "Ejercicio 09: Extensión de piernas",
      "Ejercicio 10: Flexión de pared",
      "Ejercicio 11: Elevación lateral de los brazos",
      "Ejercicio 12: Extensión de brazos",
      "Ejercicio 13: Escurrir toalla",
      "Ejercicio 14: Inclinaciones laterales",
    ],
  },

  pautasejercicioslogrehab: {
    label: "Pautas / Ejercicios de logopedia y rehabilitación",
    sub: [
      "Maniobras posturales: Maniobra de flexión anterior",
      "Maniobras posturales: Maniobra flexo-rotación",
      "Praxias neuromusculares: Ejercicio de lengua (Ejercicio 01)",
      "Praxias neuromusculares: Ejercicio de lengua (Ejercicio 02)",
      "Praxias neuromusculares: Ejercicio de lengua (Ejercicio 03)",
      "Praxias neuromusculares: Ejercicio de lengua (Ejercicio 04)",
      "Praxias neuromusculares: Ejercicio de lengua (Ejercicio 05)",
      "Praxias neuromusculares: Ejercicio de lengua (Ejercicio 06)",
      "Praxias neuromusculares: Ejercicio de lengua (Ejercicio 07)",
      "Praxias neuromusculares: Ejercicio de fuerza lingual (Video)",
      "Praxias neuromusculares: Ejercicio de movilidad de lengua (Video)",
      "Praxias neuromusculares: Ejercicio de labios y mejillas (Ejercicio 01)",
      "Praxias neuromusculares: Ejercicio de labios y mejillas (Ejercicio 02)",
      "Praxias neuromusculares: Ejercicio de labios y mejillas (Ejercicio 03)",
      "Praxias neuromusculares: Ejercicio de labios y mejillas (Ejercicio 04)",
      "Praxias neuromusculares: Ejercicio de labios y mejillas (Ejercicio 05)",
      "Praxias neuromusculares: Ejercicio de labios y mejillas (Ejercicio 06)",
      "Praxias neuromusculares: Ejercicio de labios y mejillas (Ejercicio 07)",
      "Praxias neuromusculares: Ejercicio para fortalecer el sello labial (Video)",
      "Praxias neuromusculares: Ejercicio de velo de paladar y elevación laríngea (Ejercicio 01)",
      "Praxias neuromusculares: Ejercicio de velo de paladar y elevación laríngea (Ejercicio 02)",
      "Praxias neuromusculares: Ejercicio de velo de paladar y elevación laríngea (Ejercicio 03)",
      "Praxias neuromusculares: Ejercicio de velo de paladar y elevación laríngea (Ejercicio 04)",
      "Praxias neuromusculares: Ejercicio de velo de paladar y elevación laríngea (Ejercicio 05)",
      "Praxias neuromusculares: Ejercicio de velo de paladar y elevación laríngea (Ejercicio 06)",
      "Praxias neuromusculares: Ejercicio de velo del paladar y coaptacion de cuerdas vocales (Video)",
      "Praxias neuromusculares: Ejercicio de Saker",
      "Praxias neuromusculares: Ejercicio para potenciar musculatura buccinadora (Video)",
      "Praxias neuromusculares: Ejercicio para potenciar la musculatura suprahioidea (Video)",
      "Maniobras deglutorias compensatorias: Maniobra supraglótica",
      "Maniobras deglutorias compensatorias: Maniobra de deglución forzada (Video)",
      "Maniobras deglutorias compensatorias: Maniobra de doble deglución (Video)",
      "Maniobras deglutorias compensatorias: Maniobra de Masako",
      "Maniobras deglutorias compensatorias: Maniobra de Mendelson",
    ],
  },

  farmacos: {
    label: "Disfagia y fármacos",
    sub: ["Guía de administración de medicamentos para pacientes con disfagia"],
  },
};

/* ============================================================
   LINKS
============================================================ */

const LINKS = {
  "Material necesario para realizar el MECV-V":
    "https://drive.google.com/file/d/1v5cYZZmgNLBvddHxwQLYBghN8Edmioee/view?usp=sharing",
  "Método de Exploración Clínica Volumen-Viscosidad (MECV-V)":
    "https://drive.google.com/file/d/174TPeWS27rz8Txo7QRELH631F3tNNCTe/view?usp=sharing",
  "Video 01 - Método de exploración clínica volumen viscosidad (MECV-V)":
    "https://drive.google.com/file/d/1B4aAd8GbpSab08fx20xbHSL0qwq9ldys/view?usp=sharing",
  "Video 02 - Inicio del test de deglución: viscosidad líquida (agua)":
    "https://drive.google.com/file/d/1DIrv47pyX2fkxtUJw1UHNk0MrPwRVAYn/view?usp=sharing",
  "Video 03 - Inicio del test de deglución: viscosidad néctar":
    "https://drive.google.com/file/d/1bR8lk6f6QICCNF5HoX4HE6x2qcsLEodt/view?usp=sharing",
  "Video 04 - Inicio del test de deglución: viscosidad pudín":
    "https://drive.google.com/file/d/1m8DPo_BAvzYNpm1oZ5LAYZxsEtroxwVF/view?usp=sharing",

  "Eating Assessment Tool-10 (EAT-10)":
    "https://drive.google.com/file/d/1fzKtnjIl-hK1Myfq2w8L-MHzLatQJl51/view?usp=sharing",

  "Recomendaciones generales":
    "https://drive.google.com/file/d/1PjCTe4tcprsQLKvnYzV0J4MaPziMzlt-/view?usp=sharing",
  "Recomendaciones dietéticas generales":
    "https://drive.google.com/file/d/1mOHbbhltNNkq9321wkxLA19Si_oMBNZG/view?usp=sharing",
  "Recomendaciones dietéticas sobre el uso de espesante":
    "https://drive.google.com/file/d/1nBkOf67asAV-H-TV6S9DA1JzDYtrPFl4/view?usp=sharing",
  "Recomendaciones dietéticas características de la viscosidad néctar":
    "https://drive.google.com/file/d/1GuoeVP-rAG6owR4zmSQ6BQ8qmonTH0XZ/view?usp=sharing",
  "Recomendaciones dietéticas características de la consistencia pudín":
    "https://drive.google.com/file/d/16CgAoR6ikpiCCEVspMYrqqxHYtg56Hzm/view?usp=sharing",

  "Recetas de disfagia":
    "https://drive.google.com/file/d/1d-hRaGXKnSYrG_NNl3_c5GEvJhx1Fcj0/view?usp=sharing",
  "Menús adaptados para disfagia: Menú textura néctar-miel (sin espesante)":
    "https://drive.google.com/file/d/1o58Y_ycyjzBnW6QJr97Ia814Agg8E2RJ/view?usp=sharing",
  "Menús adaptados para disfagia: Menú textura pudin (sin espesante)":
    "https://drive.google.com/file/d/1iyk6U57YPMshlYc7VUcmBB832-u-k8--/view?usp=sharing",

  "Ejercicio 01: Caminar (en llano y desnivel)":
    "https://drive.google.com/file/d/19Zc6VFV-mzyDylnA-G71LK2Qo0L5OiBm/view?usp=sharing",
  "Ejercicio 02: Sentadilla":
    "https://drive.google.com/file/d/1fCtp7JjgSaLjAQBFShUkNGu73gHPizbS/view?usp=sharing",
  "Ejercicio 03: Extensión de piernas":
    "https://drive.google.com/file/d/1Z5pYrnhdeJMP_9V6H8dhVQspfMcaKZsX/view?usp=sharing",
  "Ejercicio 04: Inclinaciones laterales":
    "https://drive.google.com/file/d/1tnD0ey7ydQsBP0wkNwEoGs2lN30qMdvF/view?usp=sharing",
  "Ejercicio 05: Cerrar codos":
    "https://drive.google.com/file/d/1zE5-dmijUXrmTAD6yVLCq5dkmZY2pLf0/view?usp=sharing",
  "Ejercicio 06: Flexión de brazos":
    "https://drive.google.com/file/d/1zJSAEVzeatMxhQK9QStTGIzATN0Hk0q-/view?usp=sharing",
  "Ejercicio 07: Fuerza de prensión manual":
    "https://drive.google.com/file/d/1I5haUh0cLRlj9JuPQfmhAZ0-NQHJuCCe/view?usp=sharing",
  "Ejercicio 08: Extensión de rodillas en sedestación":
    "https://drive.google.com/file/d/1Ka-0YDKQFeVGRZIfW77FYlTB-W2tuyE3/view?usp=sharing",
  "Ejercicio 09: Extensión de piernas":
    "https://drive.google.com/file/d/10XvpPohnMAc6xJJQqb5NAyBVMntA3qfa/view?usp=sharing",
  "Ejercicio 10: Flexión de pared":
    "https://drive.google.com/file/d/1pl0n3wdXQf5xa6e-x7GIu-mlbubl-S6W/view?usp=sharing",
  "Ejercicio 11: Elevación lateral de los brazos":
    "https://drive.google.com/file/d/1Tmkpfl_DOwgwS3ItX3CVOAbnr8W_1CF0/view?usp=sharing",
  "Ejercicio 12: Extensión de brazos":
    "https://drive.google.com/file/d/1-ygD7Vejqzo-rUIJMbL7ragtomb1Oi-5/view?usp=sharing",
  "Ejercicio 13: Escurrir toalla":
    "https://drive.google.com/file/d/1dml2m2yc3d-EMfI-Jjz576p6EtPpe5X5/view?usp=sharing",
  "Ejercicio 14: Inclinaciones laterales":
    "https://drive.google.com/file/d/1L1x1I32iE5GQEZhyBIWzFiwH6JUA6i0h/view?usp=sharing",

  "Maniobras posturales: Maniobra de flexión anterior":
    "https://disfapp.es/maniobras-posturales-flexion-anterior",
  "Maniobras posturales: Maniobra flexo-rotación":
    "https://disfapp.es/maniobras-posturales-flexo-rotacion",

  "Praxias neuromusculares: Ejercicio de lengua (Ejercicio 01)":
    "https://disfapp.es/ejercicios-de-lengua-1",
  "Praxias neuromusculares: Ejercicio de lengua (Ejercicio 02)":
    "https://disfapp.es/ejercicios-de-lengua-2",
  "Praxias neuromusculares: Ejercicio de lengua (Ejercicio 03)":
    "https://disfapp.es/ejercicios-de-lengua-3",
  "Praxias neuromusculares: Ejercicio de lengua (Ejercicio 04)":
    "https://disfapp.es/ejercicios-de-lengua-4",
  "Praxias neuromusculares: Ejercicio de lengua (Ejercicio 05)":
    "https://disfapp.es/ejercicios-de-lengua-5",
  "Praxias neuromusculares: Ejercicio de lengua (Ejercicio 06)":
    "https://disfapp.es/ejercicios-de-lengua-6",
  "Praxias neuromusculares: Ejercicio de lengua (Ejercicio 07)":
    "https://disfapp.es/ejercicios-de-lengua-7",

  "Praxias neuromusculares: Ejercicio de fuerza lingual (Video)":
    "https://drive.google.com/file/d/14jM_vrmbPU3nmDZyE0oTw0bJ3z_DSquz/view?usp=sharing",
  "Praxias neuromusculares: Ejercicio de movilidad de lengua (Video)":
    "https://drive.google.com/file/d/14jKRoCt9FhuT6vM51iNR9KCBtKl1bB5f/view?usp=sharing",

  "Praxias neuromusculares: Ejercicio de labios y mejillas (Ejercicio 01)":
    "https://disfapp.es/ejercicios-de-labios-y-mejillas-1",
  "Praxias neuromusculares: Ejercicio de labios y mejillas (Ejercicio 02)":
    "https://disfapp.es/ejercicios-de-labios-y-mejillas-2",
  "Praxias neuromusculares: Ejercicio de labios y mejillas (Ejercicio 03)":
    "https://disfapp.es/ejercicios-de-labios-y-mejillas-3",
  "Praxias neuromusculares: Ejercicio de labios y mejillas (Ejercicio 04)":
    "https://disfapp.es/ejercicios-de-labios-y-mejillas-4",
  "Praxias neuromusculares: Ejercicio de labios y mejillas (Ejercicio 05)":
    "https://disfapp.es/ejercicios-de-labios-y-mejillas-5",
  "Praxias neuromusculares: Ejercicio de labios y mejillas (Ejercicio 06)":
    "https://disfapp.es/ejercicios-de-labios-y-mejillas-6",
  "Praxias neuromusculares: Ejercicio de labios y mejillas (Ejercicio 07)":
    "https://disfapp.es/ejercicios-de-labios-y-mejillas-7",

  "Praxias neuromusculares: Ejercicio para fortalecer el sello labial (Video)":
    "https://drive.google.com/file/d/1XINbcXAxuMWRkC1zVgpX1hKIBSc9npBb/view?usp=sharing",

  "Praxias neuromusculares: Ejercicio de velo de paladar y elevación laríngea (Ejercicio 01)":
    "https://disfapp.es/ejercicios-de-velo-de-paladar-y-elevacion-laringea-1",
  "Praxias neuromusculares: Ejercicio de velo de paladar y elevación laríngea (Ejercicio 02)":
    "https://disfapp.es/ejercicios-de-velo-de-paladar-y-elevacion-laringea-2",
  "Praxias neuromusculares: Ejercicio de velo de paladar y elevación laríngea (Ejercicio 03)":
    "https://disfapp.es/ejercicios-de-velo-de-paladar-y-elevacion-laringea-3",
  "Praxias neuromusculares: Ejercicio de velo de paladar y elevación laríngea (Ejercicio 04)":
    "https://disfapp.es/ejercicios-de-velo-de-paladar-y-elevacion-laringea-4",
  "Praxias neuromusculares: Ejercicio de velo de paladar y elevación laríngea (Ejercicio 05)":
    "https://disfapp.es/ejercicios-de-velo-de-paladar-y-elevacion-laringea-5",
  "Praxias neuromusculares: Ejercicio de velo de paladar y elevación laríngea (Ejercicio 06)":
    "https://disfapp.es/ejercicios-de-velo-de-paladar-y-elevacion-laringea-6",

  "Praxias neuromusculares: Ejercicio de velo del paladar y coaptacion de cuerdas vocales (Video)":
    "https://drive.google.com/file/d/1VYZvwbWqQX3SIoOR5rdS7Lp9gsxPQb3j/view?usp=sharing",

  "Praxias neuromusculares: Ejercicio de Saker":
    "https://disfapp.es/ejercicios-de-saker",

  "Praxias neuromusculares: Ejercicio para potenciar musculatura buccinadora (Video)":
    "https://drive.google.com/file/d/1hcqr7QX8jshOwbA16LEb2YhmN7-hMgY5/view?usp=sharing",
  "Praxias neuromusculares: Ejercicio para potenciar la musculatura suprahioidea (Video)":
    "https://drive.google.com/file/d/1gM0084Zs5VXAZjg_GKLsjywMjzIqh2Ja/view?usp=sharing",

  "Maniobras deglutorias compensatorias: Maniobra supraglótica":
    "https://disfapp.es/maniobras-compensatorias-supraglotica",
  "Maniobras deglutorias compensatorias: Maniobra de deglución forzada (Video)":
    "https://drive.google.com/file/d/1gZa4hMncDnY61iZz7M5uOtCn8EaEVF3q/view?usp=sharing",
  "Maniobras deglutorias compensatorias: Maniobra de doble deglución (Video)":
    "https://drive.google.com/file/d/1caZxP4CZV9rC2bnQ36_wCQ5H2gwIuw7j/view?usp=sharing",

  "Maniobras deglutorias compensatorias: Maniobra de Masako":
    "https://disfapp.es/maniobras-compensatorias-masako",
  "Maniobras deglutorias compensatorias: Maniobra de Mendelson":
    "https://disfapp.es/maniobra-de-mendelson",

  "Guía de administración de medicamentos para pacientes con disfagia":
    "https://drive.google.com/file/d/1pEEMSkeRmba5tBWzL0_4bV1_OkIQtVJu/view?usp=sharing",
};

/* ============================================================
   Carga dinámica de librerías
============================================================ */

const loadJsPDF = () =>
  new Promise((resolve) => {
    if (window.jspdf) return resolve();
    const s = document.createElement("script");
    s.src = "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
    s.onload = resolve;
    document.body.appendChild(s);
  });

const loadAutoTable = () =>
  new Promise((resolve) => {
    if (window.jspdfAutoTable) return resolve();
    const s = document.createElement("script");
    s.src =
      "https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/3.5.28/jspdf.plugin.autotable.min.js";
    s.onload = resolve;
    document.body.appendChild(s);
  });

const loadQRCodeLib = () =>
  new Promise((resolve) => {
    if (window.QRCode) return resolve();
    const s = document.createElement("script");
    s.src = "https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js";
    s.onload = resolve;
    document.body.appendChild(s);
  });

/* ============================================================
   COMPONENTE PRINCIPAL
============================================================ */

export default function PautasVisita() {
  const navigate = useNavigate();
  const { id: pacienteId, vid: visitaId } = useParams();

  const [seleccion, setSeleccion] = useState({});
  const [paciente, setPaciente] = useState(null);
  const [visita, setVisita] = useState(null);
  const [loading, setLoading] = useState(true);

  /* ============================================================
     CARGAR PACIENTE, VISITA Y PAUTAS
  ============================================================ */

  useEffect(() => {
    const cargar = async () => {
      const pacienteRef = doc(db, "pacientes", pacienteId);
      const visitaRef = doc(db, "pacientes", pacienteId, "visitas", visitaId);
      const pautasRef = doc(db, "pacientes", pacienteId, "visitas", visitaId, "pautas", "main");

      const pSnap = await getDoc(pacienteRef);
      if (pSnap.exists()) setPaciente(pSnap.data());

      const vSnap = await getDoc(visitaRef);
      if (vSnap.exists()) setVisita(vSnap.data());

      const sSnap = await getDoc(pautasRef);
      if (sSnap.exists()) setSeleccion(sSnap.data());

      setLoading(false);
    };
    cargar();
  }, [pacienteId, visitaId]);

  /* ============================================================
     GUARDAR SELECCIÓN
  ============================================================ */

  const guardarSeleccion = async () => {
    const ref = doc(db, "pacientes", pacienteId, "visitas", visitaId, "pautas", "main");

    await setDoc(
      ref,
      {
        ...seleccion,
        creadoPor: auth.currentUser.uid,
      },
      { merge: true }
    );

    alert("Pautas guardadas correctamente.");
  };

  /* ============================================================
     GENERAR PDF MODIFICADO
============================================================ */

  const generarPDF = async () => {
    await loadJsPDF();
    await loadAutoTable();
    await loadQRCodeLib();

    const azul = [46, 116, 181];
    const azulOscuro = [26, 74, 122];

    const PDF = new window.jspdf.jsPDF();
    const pageHeight = PDF.internal.pageSize.height;
    const pageWidth = PDF.internal.pageSize.getWidth();

    const codigoPaciente = paciente?.codigo || "—";
    const sexoPaciente = paciente?.sexo || paciente?.genero || "—";
    const edadPaciente = paciente?.edad || "—";

    const fechaVisita = visita?.fecha || new Date().toISOString().slice(0, 10);
    const fechaFormateada = new Date(fechaVisita).toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    /* ---------------------- HEADER ---------------------- */
    const addHeader = () => {
      // LOGO CENTRADO
      const logoWidth = 80;
      const logoX = (pageWidth - logoWidth) / 2;
      PDF.addImage(logotipo, "PNG", logoX, 10, logoWidth, 25);

      // TÍTULO CENTRADO
      PDF.setTextColor(...azulOscuro);
      PDF.setFontSize(18);
      PDF.text("Recomendaciones y pautas", pageWidth / 2, 45, {
        align: "center",
      });

      // PACIENTE / SEXO / EDAD EN UNA LÍNEA
      PDF.setTextColor(0, 0, 0);
      PDF.setFontSize(12);

      const infoLinea = `Paciente: ${codigoPaciente}    Sexo: ${sexoPaciente}    Edad: ${edadPaciente}`;
      PDF.text(infoLinea, 14, 60);

      // FECHA DE LA VISITA DEBAJO
      PDF.text(`Fecha de la visita: ${fechaFormateada}`, 14, 68);

      PDF.setDrawColor(180);
      PDF.line(10, 74, pageWidth - 10, 74);
    };

    addHeader();

    /* ---------------------- TABLA ---------------------- */
    let y = 84;
    const filas = [];

    Object.keys(OPCIONES).forEach((cat) => {
      const arr = seleccion[cat] || [];
      if (arr.length) {
        filas.push([OPCIONES[cat].label]);
        arr.forEach((t) => filas.push(["• " + t]));
      }
    });

    PDF.autoTable({
      head: [["Recomendaciones y pautas seleccionadas en la visita"]],
      body: filas.length ? filas : [["(No se seleccionaron pautas)"]],
      startY: y,
      headStyles: { fillColor: azul, textColor: 255 },
      styles: { fontSize: 11 },
    });

    y = PDF.lastAutoTable.finalY + 18;

    /* ---------------------- QR ---------------------- */
    PDF.setTextColor(...azul);
    PDF.setFontSize(16);
    PDF.text("Acceso rápido (QR)", 14, y);
    y += 12;

    for (const categoriaKey of Object.keys(OPCIONES)) {
      const categoria = OPCIONES[categoriaKey];
      const seleccionadas = seleccion[categoriaKey] || [];

      if (!seleccionadas.length) continue;

      if (y > pageHeight - 40) {
        PDF.addPage();
        addHeader();
        y = 84;
      }

      PDF.setTextColor(...azul);
      PDF.setFontSize(14);
      PDF.text(categoria.label, 14, y);
      y += 10;

      for (const item of seleccionadas) {
        const url = LINKS[item];
        if (!url) continue;

        if (y > pageHeight - 65) {
          PDF.addPage();
          addHeader();
          y = 84;
        }

        // QR temporal
        const temp = document.createElement("div");
        temp.style.display = "none";
        document.body.appendChild(temp);

        new window.QRCode(temp, {
          text: url,
          width: 300,
          height: 300,
          margin: 1,
          correctLevel: window.QRCode.CorrectLevel.H,
        });

        await new Promise((r) => setTimeout(r, 200));
        const img = temp.querySelector("img");

        PDF.setDrawColor(...azul);
        PDF.setLineWidth(0.6);
        PDF.rect(10, y - 4, 190, 52, "S");

        if (img) {
          PDF.addImage(img.src, "PNG", 15, y, 40, 40);
        }

        PDF.setFontSize(12);
        PDF.setTextColor(0, 0, 0);
        PDF.text(item, 60, y + 22);

        temp.remove();
        y += 60;
      }
    }

    PDF.save(`Pautas_${codigoPaciente}_${visitaId}.pdf`);
  };

  /* ============================================================
     TOGGLE CHECKBOX
============================================================ */

  const toggle = (cat, sub) => {
    setSeleccion((prev) => {
      const arr = prev[cat] || [];
      return {
        ...prev,
        [cat]: arr.includes(sub)
          ? arr.filter((x) => x !== sub)
          : [...arr, sub],
      };
    });
  };

  /* ============================================================
     UI
============================================================ */

  if (loading) return <p className="p-4 text-center">Cargando…</p>;

  return (
    <div className="p-4 max-w-xl mx-auto flex flex-col gap-4">

      <div className="flex items-center justify-between">
        <Button
          onClick={() =>
            navigate(`/pacientes/${pacienteId}/visitas/${visitaId}`)
          }
          className="flex items-center gap-1 px-3 py-1.5"
        >
          Volver a la visita
        </Button>

        <h4 className="font-bold text-right">
          Selecciona las recomendaciones y pautas para generar el PDF
        </h4>
      </div>

      {Object.keys(OPCIONES).map((key) => {
        const cat = OPCIONES[key];
        return (
          <div key={key} className="border rounded p-3 bg-white flex flex-col gap-2">
            <h5 className="font-semibold underline">{cat.label}</h5>

            {cat.sub.map((s) => (
              <label key={s} className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={seleccion[key]?.includes(s) || false}
                  onChange={() => toggle(key, s)}
                />
                {s}
              </label>
            ))}
          </div>
        );
      })}

      <div className="flex flex-col gap-3 mt-4">
        <Button onClick={guardarSeleccion}>Guardar selección</Button>

        <Button
          onClick={generarPDF}
          className="bg-green-600 hover:bg-green-700 text-white"
        >
          Generar PDF
        </Button>
      </div>
    </div>
  );
}